import axios from 'axios';
import qs from 'query-string';
import { BasePageParams, PageRes } from '@/types/global';
import { BaseCustomer } from '@/types/customer';

/**
 * 公共池客户接口定义
 */
export interface PublicCustomerRecord extends BaseCustomer {
  /** 项目 */
  project: string;
  /** 客户是否已分配，0-未分配，1-已分配 */
  is_distribute: number;
}

/**
 * 公共池客户列表接口参数定义
 */
export interface PublicCustomerParams extends Partial<PublicCustomerRecord> {
  /** 关键词，可选 */
  keyword?: string;
  /** 当前页码，必填 */
  page: number;
  /** 是否已分配，0-未分配，1-已分配 */
  is_distribute: number;
  /** 每页数量，可选 */
  pageSize?: number;
}

/**
 * 公共池客户列表接口定义
 */
export interface PublicCustomerListRes {
  /** 总记录数 */
  total: number;
  /** 每页数量 */
  pageSize: number;
  /** 当前页码 */
  page: number;
  /** 总页数 */
  lastPage: number;
  /** 客户列表 */
  list: PublicCustomerRecord[];
}

/**
 * 查询公共池客户列表
 * @param params 查询参数，包含筛选条件和分页信息
 * @returns Promise<PublicCustomerListRes> 返回客户列表数据
 */
export function queryPublicCustomerList(params: PublicCustomerParams) {
  return axios.get<PublicCustomerListRes>('/tool/public_pool_list', {
    params,
    paramsSerializer: (obj) => qs.stringify(obj),
  });
}

/**
 * 分配客户接口参数定义
 */
export interface DistributeCustomerParams {
  /** 员工ID */
  staff_id: number;
  /** 用户ID列表 */
  user_ids: number[];
  /** 分配数量，暂不使用 */
}

/**
 * 分配客户
 * user_ids 和 number 只能二选一
 * number，随机分配最大数量为number
 */
export function distributeCustomer(data: DistributeCustomerParams) {
  return axios.post('/tool/distribute_customer', data);
}

/**
 * 新增客户
 */
export function addCustomer(data: Partial<BaseCustomer>) {
  return axios.post('/customer/addCustomer', data);
}

/**
 * 查询客户列表
 * @param params 查询参数，包含筛选条件和分页信息
 * @param params.keyword 关键词，可选
 * @param params.page 当前页码，必填
 * @param params.pageSize 每页数量，可选
 * @param params.id 需要查询星推官/团队长的客户，可选
 * @returns Promise<PageRes<BaseCustomer>> 返回客户列表数据
 */
export function queryCustomerList(params: BasePageParams) {
  return axios.get<PageRes<BaseCustomer>>(
    `/my_customer/index?${qs.stringify(params)}`
  );
}

/**
 * 查询团队客户列表
 * @param params 查询参数，包含筛选条件和分页信息
 * @returns Promise<PageRes<BaseCustomer>> 返回客户列表数据
 */
export function queryTeamCustomerList(params: BasePageParams) {
  return axios.get<PageRes<BaseCustomer>>('/team_customer/index', {
    params,
    paramsSerializer: (obj) => qs.stringify(obj),
  });
}

/**
 * 查询客户信息
 * @param mobile 客户手机号
 * @returns Promise<BaseCustomer> 返回客户信息数据
 */
export function queryCustomerInfo(mobile: string) {
  return axios.post<BaseCustomer>('/customer/query_customer', { mobile });
}
